import { render, staticRenderFns } from "./Erweima.vue?vue&type=template&id=2c7d0a09&scoped=true&"
import script from "./Erweima.vue?vue&type=script&lang=ts&"
export * from "./Erweima.vue?vue&type=script&lang=ts&"
import style0 from "./Erweima.vue?vue&type=style&index=0&id=2c7d0a09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d0a09",
  null
  
)

component.options.__file = "Erweima.vue"
export default component.exports